import {
  Directive,
  HostListener,
  Input,
  OnChanges,
  SimpleChanges,
  inject,
} from '@angular/core';
import {
  AuthServiceInjectionToken,
  FzGoogleTagManagerService,
} from '@fantaz/shared/data-access/api';
import { GAEventKeys } from '@fantaz/shared/data-access/models';

@Directive({
  selector: '[fzOpenZenDesk]',
})
export class OpenZenDeskDirective implements OnChanges {
  authService = inject(AuthServiceInjectionToken);

  @Input() openZendeskAction = false;
  openRetryTimer = 0;
  constructor(private gtmService: FzGoogleTagManagerService) {}

  @HostListener('click') onClick() {
    this.openZendesk();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['openZendeskAction']) {
      if (changes['openZendeskAction'].currentValue === true) {
        this.openZendesk();
      }
    }
  }
  openZendesk() {
    this.openRetryTimer++;
    const currentFrame: any = document.getElementById('launcher');
    const widgetOpen = document.getElementById('webWidget');
    if (
      currentFrame &&
      currentFrame?.contentWindow &&
      currentFrame?.contentWindow?.document &&
      !widgetOpen
    ) {
      this.openRetryTimer = 0;
      const currentDocument = currentFrame?.contentWindow?.document;
      const elem = currentDocument.querySelector('button');
      if (elem) {
        elem.click();
        this.gtmService.pushTag({
          event: GAEventKeys.USER_REQUEST_ZENDESK,
          user_id: this.authService.getUserId(),
          user_name: this.authService.getUserName(),
          timestamp: Date.now(),
        });
      }
    } else {
      // Retry three times to await for the ZenDesk will ready
      if (this.openRetryTimer <= 10) {
        setTimeout(() => {
          this.openZendesk();
        }, 5000);
      }
    }
  }
}
